import { render, staticRenderFns } from "./inventoryStockMovingAverageChartWidget.vue?vue&type=template&id=d7700170&"
import script from "./inventoryStockMovingAverageChartWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryStockMovingAverageChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports